// extracted by mini-css-extract-plugin
module.exports = {"filterHeading":"ItemsPage_filterHeading__ek374","excelButton":"ItemsPage_excelButton__3c4lU","icon":"ItemsPage_icon__16qLy","items":"ItemsPage_items__3Droi"};